/**
 * Step containers animations
 * Entrance animations for individual steps
 */

import { STEP_CONTAINERS_CONSTANTS } from '../constants/step-containers.constants';

export const stepContainersAnimations = {
  '@keyframes stepEntrance': {
    '0%': {
      opacity: STEP_CONTAINERS_CONSTANTS.STEP_ENTRANCE.INITIAL.OPACITY,
      transform: `scale(${STEP_CONTAINERS_CONSTANTS.STEP_ENTRANCE.INITIAL.SCALE}) translateY(${STEP_CONTAINERS_CONSTANTS.STEP_ENTRANCE.INITIAL.TRANSLATE_Y})`,
    },
    '100%': {
      opacity: STEP_CONTAINERS_CONSTANTS.STEP_ENTRANCE.FINAL.OPACITY,
      transform: `scale(${STEP_CONTAINERS_CONSTANTS.STEP_ENTRANCE.FINAL.SCALE}) translateY(${STEP_CONTAINERS_CONSTANTS.STEP_ENTRANCE.FINAL.TRANSLATE_Y})`,
    },
  },
};
